<template>
	<div class="tabs" :class="[{ mobile }, type, wide]">
		<ul>
			<li
				v-for="(tab, index) in tabs"
				:key="index"
				:class="[value == index ? 'is-active' : '', { disabled: tab.disabled }]"
				@click="selectTab(index)"
			>
				<a :class="{ disabled: tab.disabled }">
					<div class="icon">
						<i class="fas" :class="tab.icon" />
					</div>
					<p v-if="!isMobile" :style="tab.tag ? 'margin-right: 5px' : ''">
						{{ tab.name }}
					</p>
					<span v-if="tab.tag" class="tag is-info">{{ tab.tag }}</span>
				</a>
			</li>
		</ul>
		<div
			class="flaw-button-container"
			v-for="(button, index) in buttons"
			:key="index"
		>
			<button
				class="button is-small is-info"
				v-on="inputListeners"
				@click="click($event, index)"
			>
				<span class="icon"><i class="fas" :class="button.icon"/></span
				><span v-if="!isMobile">{{ button.name }}</span>
			</button>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	props: {
		tabs: {
			type: Array
		},
		type: {
			type: String,
			default: 'is-boxed'
		},
		fullwidth: {
			type: Boolean
		},
		value: {
			type: Number,
			default: 0
		},
		buttons: {
			type: Array
		}
	},
	computed: {
		...mapGetters('appStore', ['isMobile']),
		mobile() {
			return this.isMobile ? { display: 'block' } : '';
		},
		wide() {
			return this.fullwidth ? 'is-fullwidth' : '';
		},
		inputListeners() {
			return {
				...this.$listeners
			};
		}
	},
	methods: {
		selectTab(index) {
			if (!this.tabs[index].disabled) {
				this.$emit('input', index);
			}
		},
		click(event, index) {
			if (index) {
				this.$emit(`click${index}`, event);
			}
		}
	},
	created() {}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

li {
  &.disabled {
    a:hover {
      background: transparent;
    }
    p {
      color: lightgrey;
    }
    i {
      color: lightgrey;
    }
  }
  p {
    color: $dark;
  }
  a {
    padding: 8px 12px;
  }
}

.tabs.is-toggle li {
  &.is-active a {
    background: $lightest-grey;
    border-color: $lighter-grey;
  }
  a:hover {
    background: $lightest-grey;
    border-color: $lighter-grey;
  }
}

.tag {
  border-radius: 30px;
  width: 18px;
  height: 18px;
  font-size: 10px;
}

.flaw-button-container {
  border-bottom: 1px solid $lighter-grey;
  margin-top: 5px;
}
</style>
